import { render } from "./CategorySort.vue?vue&type=template&id=476e6472&scoped=true"
import script from "./CategorySort.vue?vue&type=script&lang=js"
export * from "./CategorySort.vue?vue&type=script&lang=js"

import "./CategorySort.vue?vue&type=style&index=0&id=476e6472&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476e6472"]])

export default __exports__